/**
 * Story 87.22: MissingCredentialModalService — состояние модального диалога
 * для HTTP 412 MissingCredentialError.
 *
 * Component-side подписка через signal `state`. Модал рендерится в AppComponent
 * (или в `app-shell`) и подписан на эту службу.
 */

import { Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { inject } from '@angular/core';

export interface MissingCredentialState {
  visible: boolean;
  marketplace: string;
  operation: string;
  requiredScope: string[];
  message: string;
}

const INITIAL: MissingCredentialState = {
  visible: false,
  marketplace: '',
  operation: '',
  requiredScope: [],
  message: '',
};

@Injectable({ providedIn: 'root' })
export class MissingCredentialModalService {
  private readonly router = inject(Router);

  readonly state = signal<MissingCredentialState>(INITIAL);

  show(payload: Omit<MissingCredentialState, 'visible'>): void {
    this.state.set({ ...payload, visible: true });
  }

  close(): void {
    this.state.update(s => ({ ...s, visible: false }));
  }

  /** Закрыть диалог + navigate в Settings → Marketplace Accounts. */
  goToSettings(): void {
    this.close();
    this.router.navigate(['/settings/marketplace-accounts']);
  }
}
